import type { Education } from '../types';

export const education: Education[] = [
  {
    id: 'itcollege',
    school: 'Estonian IT College',
    degree: "Bachelor's degree",
    field: 'Computer Programming / Information Technology',
    startYear: 2015,
    endYear: 2019,
  },
  {
    id: 'leisi-secondary',
    school: 'Leisi Keskkool',
    degree: 'Secondary Education',
    startYear: 2012,
    endYear: 2015,
  },
  {
    id: 'leisi-basic',
    school: 'Leisi Keskkool',
    degree: 'Basic Education',
    startYear: 2003,
    endYear: 2012,
  },
];
